/* eslint-disable */
export default {
  noResultFoundFor: 'Nessun risultato per',
  search: 'Cerca',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
